import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import translationAR from './locales/ar/translation.json';
import translationEN from './locales/en/translation.json';

// the translations
const resources = {
  ar: {
    translation: translationAR
  },
  en: {
    translation: translationEN
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar', // default language
    keySeparator: false,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    react: {
      useSuspense: true
    }
  });

export default i18n;
